import { v4 as uuidv4 } from 'uuid';
import {uploadFileToServer} from "./helpers/uploadFileToServer.ts";

export interface FileObject {
    fileId: string;
    fileName: string;
    loadingInfo: {
        task: 'starting' | 'uploading' | 'converting' | 'optimizing' | 'saving' | 'done';
        progress?: number;  // 0-100, only used when task isn't 'starting' or 'done'
    };
    fileContent?: string | null;
    type?: 'video' | 'audio' | 'image' | 'gif' | 'file' | 'link';
    originalFile?: File;  // Store the original File object
    previewUrl?: string; // URL for link previews
    transcript?: string; // For audio files
}

const isTextFile = (file: File): boolean => {
    const textTypes = [
        'application/json',
        'application/x-yaml',
        ''
    ];
    return file.type.startsWith('text/') || textTypes.includes(file.type);
};

const readTextFile = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = () => reject(reader.error);
        reader.readAsText(file);
    });
};

export const handleFileSelected = async (file: File, userObjRef: any, settingsObjRef: any, updateSelectedMedia: any, websocketRef: any, setupWebsocketHelper: any, setDynamicStateObj?: any) => {
    if (file.name.lastIndexOf('.') <= 0 || file.type === "application/zip") return;

    const fileId = uuidv4();

    // Determine media type from MIME type
    const getMediaType = (mimeType: string): FileObject['type'] => {
        if (mimeType.includes('gif')) return 'gif'
        if (mimeType.startsWith('image/')) return 'image';
        if (mimeType.startsWith('video/')) return 'video';
        if (mimeType.startsWith('audio/')) return 'audio';
        return 'file';
    };

    const type = getMediaType(file.type);
    const updatedFile: FileObject = {
        fileId,
        fileName: file.name,
        loadingInfo: {
            task: 'starting'
        },
        type,
        originalFile: file
    };

    updateSelectedMedia(fileId, updatedFile, "add");

    if (isTextFile(file)) {
        try {
            const textContent = await readTextFile(file);
            updateSelectedMedia(fileId, {
                loadingInfo: { task: 'done' },
                fileContent: textContent
            }, "update");
        } catch (error) {
            console.error('Failed to read text file:', error);
            updateSelectedMedia(fileId, null, "delete");

            // Show user-facing error message if setDynamicStateObj is available
            if (setDynamicStateObj) {
                setDynamicStateObj({
                    visiblePopup: "error",
                    errorPopupMessage: `Failed to read "${file.name}": File could not be read`
                });
            }
        }
    } else {
        await uploadFileToServer(updatedFile, userObjRef.current.user, settingsObjRef.current.isIncognito, updateSelectedMedia, websocketRef, setupWebsocketHelper, setDynamicStateObj);
    }
};